export
    class UserDetail {
    MiddleName?: string | undefined;
    LastName?: string | undefined;
    FirstName?: string | undefined;
    UserId?:number | undefined;
    FullName?:string |undefined;
}